import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from 'ngx-block-core';
import { blockComps} from './import.block.comps';
import { RouterModule } from '@angular/router';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { DelonABCModule } from '@delon/abc';
import { DelonACLModule } from '@delon/acl';
//import {AgGridModule} from "ag-grid-angular";
import { BaiduMapModule } from 'angular2-baidu-map';
import { UEditorModule } from 'ngx-ueditor';
import { DndModule } from 'ngx-drag-drop';
import { SimpledivComponent } from './components/simplediv/simplediv.component';
import { FormdivComponent } from './components/formdiv/formdiv.component';
import { ChartsdivComponent } from './components/chartsdiv/chartsdiv.component';
import { TableformdivComponent } from './components/tableformblock/tableformdiv/tableformdiv.component';
import { TableFormDateComponent } from './components/tableformblock/table-form-date/table-form-date.component';
import {PerfectScrollbarModule} from "ngx-perfect-scrollbar";
import { DrawerDivComponent } from './components/drawer-div/drawer-div.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PopOverContentComponent } from './components/pop-over-content/pop-over-content.component';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
const THIRDMODULES = [
  NgZorroAntdModule,
  //AgGridModule,
  BaiduMapModule,
  DndModule,
  DelonABCModule,
  PdfViewerModule,
  PerfectScrollbarModule
  // CKEditorModule
];
const COMPONENTS = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule
];
@NgModule({
  imports: [
    RouterModule,
    PipeModule,
    ...COMPONENTS,
    ...THIRDMODULES,
  DelonACLModule,
  UEditorModule.forRoot({
    js: [
      `./assets/ueditor/ueditor.config.js`,
      `./assets/ueditor/ueditor.all.min.js`,
    ],
    // 默认前端配置项
    options: {
      UEDITOR_HOME_URL: './assets/ueditor/'
    }
  })
    
  ],
  declarations: [
  ...blockComps, SimpledivComponent, FormdivComponent, ChartsdivComponent, TableformdivComponent, TableFormDateComponent, DrawerDivComponent, PopOverContentComponent, ],
  exports: [
    ...blockComps,
    ...THIRDMODULES,
    UEditorModule,
    DrawerDivComponent
    
    ],
    entryComponents:[
      ...blockComps,
      DrawerDivComponent
      
  ],
})
export class BlockModule { }

